const en_exclusive = {
  'flame'  : '(Flame) ',
  'water'  : '(Water) ',
  'wind'   : '(Wind) ',
  'light'  : '(Light) ',
  'shadow' : '(Shadow) ',
  'sword'  : '(Sword) ',
  'blade'  : '(Blade) ',
  'dagger' : '(Dagger) ',
  'axe'    : '(Axe) ',
  'lance'  : '(Lance) ',
  'bow'    : '(Bow) ',
  'wand'   : '(Wand) ',
  'staff'  : '(Staff) ',
}

export default en_exclusive